import { render } from "./SocialMediaListItem.vue?vue&type=template&id=2f9611fd&scoped=true"
import script from "./SocialMediaListItem.vue?vue&type=script&lang=js"
export * from "./SocialMediaListItem.vue?vue&type=script&lang=js"

import "./SocialMediaListItem.vue?vue&type=style&index=0&id=2f9611fd&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9611fd"]])

export default __exports__